(() => {
  if (window.productThreeColumnLayoutInitialized) return;
  window.productThreeColumnLayoutInitialized = true;

  const headerSelectors = [
    '.npd-product-badges',
    '.product__title',
    '.npd-product-subtitles',
    '.npd-product-rating-price',
  ];

  const nestRiskFree = (deliveryRow, riskFree) => {
    if (!deliveryRow || !riskFree) return;
    const deliveryContainer = deliveryRow.querySelector('.delivery-widget__container');
    (deliveryContainer || deliveryRow).append(riskFree);
    if (deliveryRow.dataset.riskFreeObserver === 'true') return;
    deliveryRow.dataset.riskFreeObserver = 'true';
    const observer = new MutationObserver(() => {
      const availableContainer = deliveryRow.querySelector('.delivery-widget__container');
      if (availableContainer && riskFree.parentElement !== availableContainer) availableContainer.append(riskFree);
    });
    observer.observe(deliveryRow, { childList: true, subtree: true });
  };

  const arrangeProduct = (productInfo) => {
    const product = productInfo.querySelector('.product');
    const header = product?.querySelector(':scope > [data-product-layout-header]');
    const heading = header?.querySelector('[data-product-layout-heading]');
    const lower = productInfo.querySelector('[data-product-layout-lower]');
    const boundary = productInfo.querySelector('[data-product-layout-lower-boundary]');
    const deliveryRow = productInfo.querySelector('[data-product-delivery-row]');
    const supportRow = productInfo.querySelector('[data-product-support-row]');
    const appreciatePanel = supportRow?.querySelector('[data-product-support-appreciate]');
    const detailsPanel = supportRow?.querySelector('[data-product-support-details]');
    const riskFree = productInfo.querySelector('.npd-shop-risk-free');
    if (!product || !header || !heading || !lower || !boundary) return;

    for (const selector of headerSelectors) {
      const element = productInfo.querySelector(selector);
      const destination = selector === '.npd-product-rating-price' ? header : heading;
      if (element && element.parentElement !== destination) destination.append(element);
    }

    const tradePrompt = productInfo.querySelector('[data-trade-pricing-prompt]');
    const priceNode = header.querySelector('.npd-price-copy [id^="price-"]');
    if (tradePrompt && priceNode && tradePrompt.previousElementSibling !== priceNode) priceNode.after(tradePrompt);

    const badges = heading.querySelector('.npd-product-badges');
    const rating = header.querySelector('.npd-rating-item');
    const title = heading.querySelector('.product__title');
    let metaRow = heading.querySelector('[data-product-meta-row]');
    let titleRow = heading.querySelector('[data-product-title-row]');
    if (header.classList.contains('product__purchase-header--editorial')) {
      if (metaRow && badges) heading.prepend(badges);
      metaRow?.remove();
      if (titleRow && title) {
        titleRow.before(title);
        titleRow.remove();
      }
      const priceItem = header.querySelector('.npd-price-item');
      if (rating && priceItem) priceItem.append(rating);
      header.classList.toggle('product__purchase-header--no-labels', !badges?.textContent.trim());
    } else if (badges?.textContent.trim() && rating) {
      if (titleRow && title) {
        titleRow.before(title);
        titleRow.remove();
      }
      if (!metaRow) {
        metaRow = document.createElement('div');
        metaRow.className = 'product__purchase-meta-row';
        metaRow.dataset.productMetaRow = '';
        heading.prepend(metaRow);
      }
      metaRow.append(badges, rating);
      header.classList.remove('product__purchase-header--no-labels');
    } else {
      metaRow?.remove();
      header.classList.add('product__purchase-header--no-labels');
      if (title && rating) {
        if (!titleRow) {
          titleRow = document.createElement('div');
          titleRow.className = 'product__purchase-title-row';
          titleRow.dataset.productTitleRow = '';
          title.before(titleRow);
        }
        titleRow.append(title, rating);
      }
    }

    let element = boundary.nextElementSibling;
    while (element) {
      const next = element.nextElementSibling;
      if (element.matches('[data-product-details-appreciate]') && appreciatePanel) {
        appreciatePanel.append(element);
        element = next;
        continue;
      }
      if (element.matches('[data-product-purchase-detail]') && detailsPanel) {
        detailsPanel.append(element);
        element = next;
        continue;
      }
      if (deliveryRow && (element.id.includes('c_edd_estimated_delivery_date') || element.querySelector('.delivery-widget__theme') || element.matches('.npd-shop-risk-free'))) {
        deliveryRow.append(element);
      } else {
        lower.append(element);
      }
      element = next;
    }
    // PROP65_AFTER_MATERIALS: owner direction; preserve placement after product refreshes.
    const safetyNotice = productInfo.querySelector('[data-product-details-prop65]');
    const materialsPanel = [...(supportRow?.querySelectorAll('[data-product-purchase-detail]') || [])].find(panel => panel.querySelector('summary')?.textContent.replace(/\s+/g, ' ').trim() === 'Materials & Finishes');
    const dedicatedLayout = productInfo.matches('[data-bold-layout-draft],[data-catalog-layout]');
    if (!dedicatedLayout && materialsPanel && safetyNotice && materialsPanel.nextElementSibling !== safetyNotice) materialsPanel.after(safetyNotice);
    else if (!dedicatedLayout && supportRow && safetyNotice && !materialsPanel && !supportRow.contains(safetyNotice)) supportRow.append(safetyNotice);
    productInfo.querySelectorAll('[data-bold-shipping-link]').forEach(link => {
      if (link.dataset.ihAction !== 'shipping_open') link.dataset.ihAction = 'shipping_open';
      if (link.getAttribute('aria-haspopup') !== 'dialog') link.setAttribute('aria-haspopup', 'dialog');
    });
    nestRiskFree(deliveryRow, riskFree);
    supportRow?.querySelectorAll('details').forEach((details) => {
      if (details.dataset.initialCollapseApplied === 'true') return;
      details.dataset.initialCollapseApplied = 'true';
      // PRODUCT_DETAIL_OPEN_DEFAULTS: apply once; preserve the customer's later toggles.
      const heading = details.querySelector('summary h3, summary h2, summary')?.textContent.replace(/\u2019/g, "'").replace(/\s+/g, ' ').trim();
      details.open = ["What's Included?", 'Materials & Finishes'].includes(heading);
      details.dataset.guidanceDefaultApplied = 'true';
    });
  };

  const arrangeAll = () => document.querySelectorAll('product-info').forEach(arrangeProduct);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrangeAll, { once: true });
  else arrangeAll();
  document.addEventListener('product-info:loaded', arrangeAll);
  document.addEventListener('shopify:section:load', arrangeAll);
  document.addEventListener('click', (event) => {
    const action = event.target.closest('[data-review-action]');
    if (!action) return;
    const reviews = document.querySelector('#judgeme_product_reviews');
    if (!reviews) return;
    event.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (action.dataset.reviewAction !== 'write') return;

    let attempts = 0;
    const openReviewForm = () => {
      const writeLink = reviews.querySelector('.jdgm-write-rev-link, [data-write-review]');
      if (writeLink) {
        writeLink.click();
        return;
      }
      attempts += 1;
      if (attempts < 10) window.setTimeout(openReviewForm, 200);
    };
    openReviewForm();
  });
})();
